import React, { useContext, useEffect, useRef, useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Card, Carousel, Modal } from "react-bootstrap";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Footer2 from "../components/Footer2";
import { useAuth } from "../context/auth";
import { useApp  } from "../context/appContext";
import Header3 from "../components/Header3";
import { FaVideo } from "react-icons/fa";
import { Filter, ChevronUp, ChevronDown } from "lucide-react";
import { Book, Search } from "lucide-react";

import axios from "../AxiosInstance";
import { BASE_URL } from "../config/BaseUrls";
import { resolveBookImageUrl } from "../utils/urlHelpers";
import { LanguageContext } from "../context/LanguageContext";
import {
  BookOpen,
  CalendarDays,
  Coffee,
  MapPin,
  Users,
  Video,
  SlidersHorizontal,
} from "lucide-react";

const BooksAndReview = () => {
  const itemRefs = useRef([]);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const initialLimit = isMobile ? 6 : 12;

  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const { lg } = useContext(LanguageContext);
    const {
    selectedMonth,
    setSelectedMonth,
    selectedGenre,
    setSelectedGenre,
    selectedAge,
    setSelectedAge,
    selectedType,
    setSelectedType,
    selectedLanguage,
    setSelectedLanguage,
    selectedSort,
    setSelectedSort,
    searchQuery,
    setSearchQuery,
    searchQueryName,
    setSearchQueryName,
    suggestions,
    setSuggestions,
    suggestionsName,
    setSuggestionsName,
    showPopup,
    setShowPopup,
    expandedFilter,
    setExpandedFilter,
    visibleCount,
    setVisibleCount,
    resetFilters,
  } = useApp ();
  // const [selectedMonth, setSelectedMonth] = useState("");
  // const [selectedGenre, setSelectedGenre] = useState("");
  // const [selectedAge, setSelectedAge] = useState("");
  // const [selectedType, setSelectedType] = useState("");
  // const [selectedLanguage, setSelectedLanguage] = useState("");
  // const [selectedSort, setSelectedSort] = useState("");
   const [booksFromDB, setBooksFromDB] = useState([]);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [suggestions, setSuggestions] = useState([]);
  // const [searchQueryName, setSearchQueryName] = useState("");
  // const [suggestionsName, setSuggestionsName] = useState([]);
  const [locationsss, setLocationsss] = useState("Loading...");
  const [ageRanges, setAgeRanges] = useState([]);
  const [languages, setLanguages] = useState([]);

  // Mobile filter popup states
  // const [showPopup, setShowPopup] = useState(false);
  // const [expandedFilter, setExpandedFilter] = useState(null);

  const months = [
    lg?.jan,
    lg?.feb,
    lg?.mar,
    lg?.apr,
    lg?.may,
    lg?.jun,
    lg?.jul,
    lg?.aug,
    lg?.sep,
    lg?.oct,
    lg?.nov,
    lg?.dec,
  ];

  // Cache utility functions (moved here to be accessible)
  const CACHE_DURATION = {
    BOOKS: 5 * 60 * 1000, // 5 minutes for books
    STATIC: 30 * 60 * 1000, // 30 minutes for age ranges and languages
    SUGGESTIONS: 2 * 60 * 1000, // 2 minutes for search suggestions
  };

  const getCacheKey = (baseKey, params = {}) => {
    const paramsStr = Object.keys(params)
      .sort()
      .map((key) => `${key}:${params[key]}`)
      .join("|");
    return `cache_${baseKey}_${paramsStr}`;
  };

  const getCachedData = (key) => {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return null;

      const { data, timestamp, duration } = JSON.parse(cached);
      const now = Date.now();

      if (now - timestamp > duration) {
        localStorage.removeItem(key);
        return null;
      }

      return data;
    } catch (error) {
      console.error("Error reading cache:", error);
      return null;
    }
  };

  const setCachedData = (key, data, duration) => {
    try {
      const cacheEntry = {
        data,
        timestamp: Date.now(),
        duration,
      };
      localStorage.setItem(key, JSON.stringify(cacheEntry));
    } catch (error) {
      console.error("Error setting cache:", error);
      // If localStorage is full, clear old cache entries
      if (error.name === "QuotaExceededError") {
        clearOldCache();
      }
    }
  };

  const clearOldCache = () => {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach((key) => {
        if (key.startsWith("cache_")) {
          const cached = localStorage.getItem(key);
          if (cached) {
            try {
              const { timestamp, duration } = JSON.parse(cached);
              if (Date.now() - timestamp > duration) {
                localStorage.removeItem(key);
              }
            } catch (e) {
              localStorage.removeItem(key);
            }
          }
        }
      });
    } catch (error) {
      console.error("Error clearing old cache:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Check cache for age ranges
        const ageCacheKey = getCacheKey("ageRanges");
        const cachedAges = getCachedData(ageCacheKey);
        if (cachedAges) {
          console.log("📦 Using cached age ranges");
          setAgeRanges(cachedAges);
        } else {
          const ageResponse = await axios.get(`api/v1/stores/age`);
          const ageData = ageResponse.data.data;
          setAgeRanges(ageData);
          setCachedData(ageCacheKey, ageData, CACHE_DURATION.STATIC);
        }

        // Check cache for languages
        const langCacheKey = getCacheKey("languages");
        const cachedLangs = getCachedData(langCacheKey);
        if (cachedLangs) {
          console.log("📦 Using cached languages");
          setLanguages(cachedLangs);
        } else {
          const langResponse = await axios.get(`api/v1/stores/lang`);
          const langData = langResponse.data.data;
          setLanguages(langData);
          setCachedData(langCacheKey, langData, CACHE_DURATION.STATIC);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  // Mobile filter popup handlers
  const handleCloseModal = () => {
    setShowPopup(false);
    setExpandedFilter(null);
  };

  const toggleExpanded = (filterName) => {
    const willExpand = expandedFilter !== filterName;
    setExpandedFilter(willExpand ? filterName : null);

    if (willExpand) {
      setTimeout(() => {
        const expandedElement = document.querySelector(
          `[data-filter="${filterName}"]`
        );
        if (expandedElement) {
          expandedElement.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }, 100);
    }
  };

  const FilterSection = ({
    title,
    options,
    selectedValue,
    onSelect,
    renderLabel,
  }) => {
    const isExpanded = expandedFilter === title;

    return (
      <div className="mb-3" data-filter={title}>
        <div
          onClick={() => toggleExpanded(title)}
          className="d-flex align-items-center justify-content-between p-3 bg-white border-0 w-100"
          style={{
            cursor: "pointer",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#ffffff",
          }}
        >
          <div className="text-start">
            <div
              className="fw-semibold mb-1"
              style={{
                fontSize: "18px",
                fontFamily: "Open Sans",
                color: "#3B3B3B",
              }}
            >
              {title}
            </div>
            <div
              className="text-muted"
              style={{
                fontSize: "14px",
                fontFamily: "Open Sans",
                color: "#6B7280",
              }}
            >
              {selectedValue
                ? renderLabel
                  ? renderLabel(
                      options.find((opt) =>
                        typeof opt === "object"
                          ? `${opt.minAge}-${opt.maxAge}` === selectedValue ||
                            opt.value === selectedValue
                          : opt === selectedValue
                      )
                    )
                  : selectedValue
                : title}
            </div>
          </div>
          <div
            style={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
              fontSize: "16px",
              color: "#6B7280",
            }}
          >
            ▼
          </div>
        </div>

        {isExpanded && (
          <div
            className="mt-2 p-3 bg-white"
            style={{
              borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <div className="row g-2">
              {options.map((option, index) => {
                // ✅ Build age range value
                const optionValue =
                  typeof option === "object"
                    ? option.value ||
                      option.code ||
                      (option.minAge !== undefined &&
                      option.maxAge !== undefined
                        ? `${option.minAge}-${option.maxAge}`
                        : option.label || option.name || "")
                    : option;

                const optionLabel = renderLabel
                  ? renderLabel(option)
                  : option.label ||
                    option.name ||
                    (option.minAge !== undefined && option.maxAge !== undefined
                      ? `${option.minAge}-${option.maxAge}`
                      : option);

                const isSelected = selectedValue === optionValue;

                return (
                  <div key={index} className="col-6">
                    <button
                      onClick={() => {
                        onSelect(optionValue);
                        setExpandedFilter(null); // ✅ close popup
                      }}
                      className="w-100 text-center border-0 py-2"
                      style={{
                        backgroundColor: isSelected ? "#70D4D8" : "#F3F4F6",
                        color: isSelected ? "white" : "#374151",
                        fontSize: "16px",
                        fontFamily: "Open Sans",
                        fontWeight: isSelected ? "600" : "500",
                        minHeight: "44px",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.target.style.backgroundColor = "#E5E7EB";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.target.style.backgroundColor = "#F3F4F6";
                        }
                      }}
                    >
                      {optionLabel}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Custom Modal Component
  const CustomModal = ({ show, onHide, children }) => {
    if (!show) return null;

    return (
      <div
        className="position-fixed w-100 h-100 d-flex align-items-center justify-content-center"
        style={{
          top: 0,
          left: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1050,
        }}
        onClick={onHide}
      >
        <div
          className="bg-white position-relative mx-3"
          style={{
            width: "100%",
            maxWidth: "500px",
            maxHeight: "90vh",
            borderRadius: "16px",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    );
  };

  useEffect(() => {
    const fetchLocation = () => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            const response = await axios.get(
              `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=f38094deb4434dba86652d250a85311e`
            );

            const components = response.data.results[0]?.components;
            const city =
              components?.city || components?.town || components?.village;
            const countryCode = components?.country_code?.toUpperCase();

            if (city && countryCode) {
              setLocationsss(`${city}, ${countryCode}`);
            } else if (countryCode) {
              setLocationsss(countryCode);
            } else {
              setLocationsss("Location not found");
            }
          } catch (error) {
            console.error("Error with reverse geocoding:", error);
            setLocationsss("Location not found");
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          setLocationsss("Permission denied or unavailable");
        }
      );
    };

    fetchLocation();
  }, []);

  const handleLocationClick = () => {
    if (locationsss !== "Location not found" && locationsss !== "Loading...") {
      const city = locationsss.split(",")[0];
      navigate(`/booksandreview?city=${encodeURIComponent(city)}`);
      // OLD CODE - Future use: Close ambassador modal when navigating
      // handleCloseW(true);

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 1000);
    }
  };

  const handleResetFilters = () => {
    // First, navigate without any query parameters to clear URL params
    // This ensures city and title from useSearchParams become null
    navigate("/booksandreview", { replace: true });
    
    // Call context's resetFilters function to reset all state
    resetFilters();
    
    // Also manually reset local state to ensure everything is cleared
    setSearchQuery("");
    setSearchQueryName("");
    setSelectedMonth("");
    setSelectedGenre("");
    setSelectedAge("");
    setSelectedType("");
    setSelectedLanguage("");
    setSelectedSort("");
    setSuggestions([]);
    setSuggestionsName([]);
    
    // Reset visible count and show all
    const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
    const initialLimit = isMobile ? 6 : 12;
    setVisibleCount(initialLimit);
    setShowAll(false);
    
    // The useEffect hook will automatically call fetchBooks when the state changes
    // No need to manually call it here
  };

  const isAnyFilterSelected =
    selectedMonth ||
    selectedGenre ||
    selectedAge ||
    selectedType ||
    selectedLanguage ||
    searchQuery ||
    searchQueryName ||
    selectedSort;

  const handleMonthChange = (e) => setSelectedMonth(e.target.value);
  const handleGenreChange = (e) => setSelectedGenre(e.target.value);
  const handleAgeChange = (e) => setSelectedAge(e.target.value);
  const handleTypeChange = (e) => setSelectedType(e.target.value);
  const handleLanguageChange = (e) => setSelectedLanguage(e.target.value);
  const handleSortChange = (e) => setSelectedSort(e.target.value);

  const getMonthFromEventDate = (date) => {
    const month = new Date(date.split("-")[0].trim()).getMonth() + 1;
    return month;
  };

  const navigate = useNavigate();
  const [auth] = useAuth();

  const capitalizeFirstLetter = (name) => {
    if (!name) return "";
    // Capitalize each word in the name
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const userName = capitalizeFirstLetter(auth?.user?.name);

  const handleAmbasButtonClick = () => {
    const auth = JSON.parse(localStorage.getItem("auth"));

    if (auth?.token) {
      // OLD CODE - Future use: Ambassador check
      // if (auth?.user?.isAmbassador) {
      //   localStorage.removeItem("modalClosedL");
      //   navigate("/booksdetails", { state: { show: true } });
      //   // Scroll to top on mobile devices when navigating to creation page
      //   window.scrollTo({ top: 0, behavior: 'instant' });
      // } else {
      //   handleShowW(true);
      // }
      // NEW CODE: All users can create Book Club
      localStorage.removeItem("modalClosedL");
      navigate("/booksdetails", { state: { show: true } });
      // Scroll to top on mobile devices when navigating to creation page
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      localStorage.removeItem("modalClosedH");
      navigate("/", { state: { show: true } });
    }
  };

  const handleReadingButtonClick = () => {
    const auth = JSON.parse(localStorage.getItem("auth"));

    if (auth?.token) {
      // OLD CODE - Future use: Ambassador check
      // if (auth?.user?.isAmbassador) {
      //   navigate("/silentreading");
      // } else {
      //   handleShowW(true);
      // }
      // NEW CODE: All users can create Silent Reading
      navigate("/silentreading");
    } else {
      localStorage.removeItem("modalClosedH");
      navigate("/", { state: { show: true } });
    }
  };

  const handleAmbasButtonClickModel = () => {
    localStorage.removeItem("modalClosedA");
    navigate("/ambassador", { state: { show: true } });
  };

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // OLD CODE - Future use: Ambassador restriction modal state
  // const [wShow, setWShow] = useState(false);
  // const handleCloseW = () => {
  //   setWShow(false);
  // };
  // const handleShowW = () => {
  //   setWShow(true);
  // };

  const location = useLocation();
  const [filteredBookss, setFilteredBookss] = useState([]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("type");

    if (type) {
      const onlineOnly = booksFromDB.filter(
        (book) => book.type.toLowerCase() === type.toLowerCase()
      );
      setFilteredBookss(onlineOnly);
    } else {
      setFilteredBookss(booksFromDB);
    }
  }, [location.search, booksFromDB]);

  useEffect(() => {
    if (location.hash === "#booksandreviewsboxws") {
      document
        .getElementById("booksandreviewsboxws")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const [query, setQuery] = useState("");
  const [bookss, setBookss] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    console.log("📚 Updated Books State:", bookss);
  }, [bookss]);

  const [startIndex, setStartIndex] = useState(0);
  const booksPerPage = 1;

  const showNextBooks = () => {
    setStartIndex((prev) => prev + booksPerPage);
  };

  const [searchParams] = useSearchParams();
  const city = searchParams.get("city");
  const title = searchParams.get("title");

  const [loadings, setLoadings] = useState(true);
  const searchTimeoutRef = useRef(null);
  const searchNameTimeoutRef = useRef(null);

  const fetchBooks = async (forceRefresh = false) => {
    try {
      let url = "/api/v1/books/getallbooks";
      let queryParams = [];

      if (title) queryParams.push(`title=${encodeURIComponent(title)}`);
      else if (city) queryParams.push(`city=${encodeURIComponent(city)}`);

      if (selectedMonth)
        queryParams.push(`month=${encodeURIComponent(selectedMonth)}`);
      if (selectedGenre)
        queryParams.push(`genre=${encodeURIComponent(selectedGenre)}`);
      if (selectedAge)
        queryParams.push(`age=${encodeURIComponent(selectedAge)}`);
      if (selectedType)
        queryParams.push(`type=${encodeURIComponent(selectedType)}`);
      if (selectedLanguage)
        queryParams.push(`language=${encodeURIComponent(selectedLanguage)}`);
      if (selectedSort)
        queryParams.push(`sort=${encodeURIComponent(selectedSort)}`);

      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      // Create cache key from all parameters
      const cacheKey = getCacheKey("books", {
        title,
        city,
        selectedMonth,
        selectedGenre,
        selectedAge,
        selectedType,
        selectedLanguage,
        selectedSort,
      });

      // Check cache first
      if (!forceRefresh) {
        const cachedData = getCachedData(cacheKey);
        if (cachedData) {
          console.log("📦 Using cached books data");
          let data = Array.isArray(cachedData) ? cachedData : [];
          if (!selectedSort && data.length) {
            data = [...data].sort(
              (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
            );
          }
          setBooksFromDB(data);
          setLoadings(false);
          return;
        }
      }

   
      setLoadings(true);

      const response = await axios.get(url);


      if (response.data.success && Array.isArray(response.data.data)) {
        let booksData = response.data.data;
        // When no sort filter is selected, sort by creation date (newest first)
        if (!selectedSort) {
          booksData = [...booksData].sort(
            (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
          );
        }
        setBooksFromDB(booksData);
        // Cache the data
        setCachedData(cacheKey, booksData, CACHE_DURATION.BOOKS);
      } else {
        console.error("API Response format error:", response.data);
        setBooksFromDB([]);
      }
    } catch (error) {
      console.error("Error fetching books:", error);
      setBooksFromDB([]);
    } finally {
      setLoadings(false);
    }
  };

  useEffect(() => {
    fetchBooks();
    setVisibleCount(initialLimit);
  }, [
    city,
    title,
    selectedMonth,
    selectedGenre,
    selectedAge,
    selectedType,
    selectedLanguage,
    selectedSort,
    isMobile,
  ]);

  const handleSeeMoreClick = () => {
    const increment = isMobile ? 6 : 12;
    const newCount = visibleCount + increment;

    if (newCount >= booksFromDB.length) {
      setShowAll(true);
    }
    setVisibleCount(newCount);
  };

  const handleInputChange = async (e) => {
    if (!e || !e.target) return;

    const value = e.target.value;
    setSearchQuery(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (value.trim() === "") {
      setSuggestions([]);
      return;
    }

    // Debounce search - wait 300ms before making API call
    searchTimeoutRef.current = setTimeout(async () => {
      try {
        // Check cache first
        const cacheKey = getCacheKey("citySuggestions", { query: value.trim().toLowerCase() });
        const cachedSuggestions = getCachedData(cacheKey);
        
        if (cachedSuggestions) {
          console.log("📦 Using cached city suggestions");
          setSuggestions(cachedSuggestions);
          return;
        }

        // Fetch from API
        const response = await axios.get(
          `/api/v1/books/books/searchCity?query=${encodeURIComponent(value)}`
        );
        console.log("API Response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setSuggestions(response.data.data);
          // Cache the suggestions
          setCachedData(cacheKey, response.data.data, CACHE_DURATION.SUGGESTIONS);
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      }
    }, 300);
  };

  const handleSearchCity = () => {
    if (searchQuery.trim() !== "") {
      setSuggestions([]);
      navigate(`/booksandreview?city=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleInputNameChange = async (e) => {
    if (!e || !e.target) return;
    const value = e.target.value;
    setSearchQueryName(value);

    // Clear previous timeout
    if (searchNameTimeoutRef.current) {
      clearTimeout(searchNameTimeoutRef.current);
    }

    if (value.trim() === "") {
      setSuggestionsName([]);
      return;
    }

    // Debounce search - wait 300ms before making API call
    searchNameTimeoutRef.current = setTimeout(async () => {
      try {
        // Check cache first
        const cacheKey = getCacheKey("nameSuggestions", { query: value.trim().toLowerCase() });
        const cachedSuggestions = getCachedData(cacheKey);
        
        if (cachedSuggestions) {
          console.log("📦 Using cached name suggestions");
          setSuggestionsName(cachedSuggestions);
          return;
        }

        // Fetch from API
        const response = await axios.get(
          `/api/v1/books/books/searchName?query=${encodeURIComponent(value)}`
        );
        console.log("API Response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setSuggestionsName(response.data.data);
          // Cache the suggestions
          setCachedData(cacheKey, response.data.data, CACHE_DURATION.SUGGESTIONS);
        } else {
          setSuggestionsName([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestionsName([]);
      }
    }, 300);
  };

  const handleSearchName = () => {
    if (searchQueryName.trim() !== "") {
      setSuggestionsName([]);
      navigate(`/booksandreview?title=${encodeURIComponent(searchQueryName)}`);
    }
  };

  const handleSuggestionClick = (city) => {
    setSearchQuery(city);
    setSuggestions([]);

    const params = new URLSearchParams(window.location.search);
    params.set("city", city);

    navigate(`/booksandreview?${params.toString()}`);
  };

  const handleSuggestionClickName = (book) => {
    // Handle both string (title) and object (book) for backward compatibility
    const bookTitle = typeof book === "string" ? book : book?.title;
    const bookObject = typeof book === "object" ? book : null;
    
    setSearchQueryName(bookTitle);
    setSuggestionsName([]);

    // If it's a book object, navigate to reviews page with proper setup
    if (bookObject && bookObject._id) {
      const selectedBookObj = {
        bookId: bookObject._id,
        bookCoverImage: bookObject.image,
        title: bookObject.title,
        author: bookObject.author,
        descriptions: bookObject.aboutBook || bookObject.description,
        titless: bookObject.title,
        publisher: bookObject.publisher,
        book: bookObject,
        EAN: bookObject.EAN,
        isSearchBook: true,
      };

      localStorage.setItem(
        "selectedBookforreviews",
        JSON.stringify(selectedBookObj)
      );
      localStorage.setItem(
        "selectedBookforreviewsnew",
        JSON.stringify(selectedBookObj)
      );

 
      const queryParam = bookObject.EAN
        ? `ean=${encodeURIComponent(bookObject.EAN)}`
        : `bookid=${encodeURIComponent(bookObject._id)}`;

      navigate(`/reviews?${queryParam}&searchbook=true`);
    } else {
  
      const params = new URLSearchParams(window.location.search);
      params.set("title", bookTitle);
      navigate(`/booksandreview?${params.toString()}`);
    }
  };

  const handleSearchCityOrName = () => {
    const params = new URLSearchParams();

    if (searchQueryName.trim() !== "") {
      params.set("title", searchQueryName.trim());
    }

    if (searchQuery.trim() !== "") {
      params.set("city", searchQuery.trim());
    }

    navigate(`/booksandreview?${params.toString()}`);
  };

  useEffect(() => {
    if (highlightedIndex >= 0 && itemRefs.current[highlightedIndex]) {
      itemRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);


  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
      if (searchNameTimeoutRef.current) {
        clearTimeout(searchNameTimeoutRef.current);
      }
    };
  }, []);
  return (
    <>
      <div className="booksandreviewsheader">
        <Header3 />
      </div>
      <div className="container ">
        <div className="scalminaa1">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 md:gap-1 px-4">
            <div>
              <div
                className="flex text-dark font-bold wolcom gap-2 mt-3 md:mt-5"
                style={{ fontSize: "clamp(20px, 5vw, 26px)", lineHeight: "clamp(30px, 6vw, 40.85px)" }}
              >
                {lg?.welc} {userName}
                {userName && (
                  <img
                    className="mx-2 mt-md-1 handwid"
                    src={require("../pages/image/handwelc.png")}
                    alt="logo"
                    width="37"
                    height="37"
                    style={{ width: "clamp(28px, 4vw, 37px)", height: "clamp(28px, 4vw, 37px)" }}
                  />
                )}
              </div>
            </div>

            <div className="w-full md:w-auto mt-2 md:mt-5 flex items-center gap-2">
              <InputGroup className="mt-0 md:mt-4 position-relative custom-search-bar flex-1">
                {/* Book Input with Icon */}
                <InputGroup.Text
                  className="border-0 hidden sm:flex"
                  style={{ backgroundColor: "transparent" }}
                >
                  <BookOpen size={16} color="#34C3C9" />
                </InputGroup.Text>
                <Form.Control
                  className="custom-input w-100 position-relative inu"
                  style={{
                    lineHeight: "clamp(32px, 4vw, 40px)",
                    fontSize: "clamp(14px, 3vw, 16px)",
                    padding: "clamp(6px, 1.5vw, 8px) 12px",
                  }}
                  value={searchQueryName}
                  onChange={handleInputNameChange}
                  placeholder={lg?.sbybooks || "Search here"}
                  aria-label="Search by books"
                  aria-describedby="basic-addon2"
                  onKeyDown={(e) => {
                    if (suggestionsName.length === 0) return;
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setHighlightedIndex((prevIndex) =>
                        prevIndex < suggestionsName.length - 1
                          ? prevIndex + 1
                          : 0
                      );
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setHighlightedIndex((prevIndex) =>
                        prevIndex > 0
                          ? prevIndex - 1
                          : suggestionsName.length - 1
                      );
                    } else if (e.key === "Enter") {
                      if (highlightedIndex >= 0) {
                        handleSuggestionClickName(
                          suggestionsName[highlightedIndex].title
                        );
                      }
                    }
                  }}
                />
                {suggestionsName.length > 0 && (
                  <ul className="suggestions-dropdown booksuggestions">
                    {suggestionsName.map((book, index) => (
                      <li
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        onClick={() => handleSuggestionClickName(book)}
                        style={{
                          backgroundColor:
                            index === highlightedIndex
                              ? "#34C3C9"
                              : "transparent",
                          cursor: "pointer",
                          padding: "8px 10px",
                        }}
                      >
                        {book.title} - {book.author}
                      </li>
                    ))}
                  </ul>
                )}

                {/* City/Zip Input with Icon */}
                <InputGroup.Text
                  className="border-0 position-relative hidden sm:flex"
                  style={{ backgroundColor: "transparent" }}
                >
                  <MapPin size={16} color="#34C3C9" />
                  <div
                    style={{
                      position: "absolute",
                      height: "24px",
                      left: "0px",
                      width: "1px",
                      backgroundColor: "#E5E7EB",
                    }}
                  ></div>
                </InputGroup.Text>
                <InputGroup.Text
                  className="border-0 p-0 position-relative flex sm:hidden"
                  style={{ zIndex: "222", backgroundColor: "transparent" }}
                >
                  <div
                    style={{
                      position: "absolute",
                      height: "24px",
                      left: "0px",
                      width: "1px",
                      backgroundColor: "#E5E7EB",
                    }}
                  ></div>
                </InputGroup.Text>
                <Form.Control
                  className="custom-input placeholder-1 position-relative"
                  placeholder={lg?.city || "City"}
                  aria-label={lg?.city || "City"}
                  aria-describedby="basic-addon2"
                  style={{
                    maxWidth: "200px",
                    width: "100%",
                    lineHeight: "clamp(32px, 4vw, 40px)",
                    fontSize: "clamp(14px, 3vw, 16px)",
                    padding: "clamp(6px, 1.5vw, 8px) 12px",
                  }}
                  value={searchQuery}
                  onChange={handleInputChange}
                  onKeyDown={(e) => {
                    if (suggestions.length === 0) return;
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setHighlightedIndex((prevIndex) =>
                        prevIndex < suggestions.length - 1 ? prevIndex + 1 : 0
                      );
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setHighlightedIndex((prevIndex) =>
                        prevIndex > 0 ? prevIndex - 1 : suggestions.length - 1
                      );
                    } else if (e.key === "Enter") {
                      if (highlightedIndex >= 0) {
                        handleSuggestionClick(
                          suggestions[highlightedIndex].city
                        );
                      } else {
                        handleSearchCity();
                      }
                    }
                  }}
                />
                {suggestions.length > 0 && (
                  <ul className="suggestions-dropdown booksuggestions citysugg">
                    {suggestions.map((city, index) => (
                      <li
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        style={{
                          backgroundColor:
                            index === highlightedIndex
                              ? "#34C3C9"
                              : "transparent",
                          cursor: "pointer",
                          padding: "8px 10px",
                        }}
                        onClick={() => handleSuggestionClick(city.city)}
                      >
                        {city.city}, {city.country}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Search Button with Icon */}
                <InputGroup.Text
                  className="custom-button"
                  id="basic-addon2"
                  onClick={handleSearchCityOrName}
                  style={{
                    padding: "clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)",
                  }}
                >
                  <Search size={18} color="#FFFFFF" style={{ width: "clamp(14px, 3vw, 18px)", height: "clamp(14px, 3vw, 18px)" }} />
                </InputGroup.Text>
              </InputGroup>
              
              {/* Filter Button - Mobile */}
              <button
                onClick={() => setShowPopup(true)}
                className="flex items-center justify-center text-white border-0 rounded-xl sm:hidden"
                style={{
                  backgroundColor: "#34C3C9",
                  height: "clamp(32px, 8vw, 40px)",
                  width: "clamp(40px, 10vw, 50px)",
                  minWidth: "clamp(40px, 10vw, 50px)",
                  borderRadius: "12px",
                  boxShadow: "0 2px 8px rgba(52, 195, 201, 0.3)",
                  transition: "all 0.2s ease",
                  padding: "8px",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#2BB3BA";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#34C3C9";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                <SlidersHorizontal size={18} style={{ width: "clamp(16px, 4vw, 18px)", height: "clamp(16px, 4vw, 18px)" }} />
                {isAnyFilterSelected && (
                  <span
                    className="absolute -top-1 -right-1 bg-white rounded-full flex items-center justify-center"
                    style={{
                      color: "#34C3C9",
                      fontSize: "10px",
                      minWidth: "18px",
                      height: "18px",
                      padding: "2px 6px",
                      fontWeight: "bold",
                    }}
                  >
                    {
                      [
                        selectedMonth,
                        selectedGenre,
                        selectedAge,
                        selectedType,
                        selectedLanguage,
                        selectedSort,
                      ].filter(Boolean).length
                    }
                  </span>
                )}
              </button>
            </div>
          </div>

          <div className="hidden sm:flex mt-5 flex-wrap gap-3 px-4">
            {/* Month Selector */}
            <div className="" style={{ width: "136px", minWidth: "136px" }}>
              <Form.Select
                aria-label="Select Month"
                className={`outline11 pxff-4 pright pt-0 ftzcopy ${selectedMonth ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedMonth ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedMonth ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedMonth} // Bind the value to the selected month
                onChange={handleMonthChange} // Handle change in month selection
              >
                <option value="">{lg?.month} &nbsp; &nbsp; &nbsp;</option>
                {months.map((month, index) => (
                  <option key={index} value={month}>
                    {month}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/* Genre Selector */}
            <div className="" style={{ width: "180px", minWidth: "180px" }}>
              <Form.Select
                aria-label="Select Genre"
                className={`outline11 pxee-4 pright pt-0 ftzcopy ${selectedGenre ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedGenre ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedGenre ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedGenre} // Bind the value to the selected genre
                onChange={handleGenreChange} // Handle change in genre selection
              >
                <option value="">{lg?.genre}</option>
                <option value="Crime">{lg?.cri}</option>
                <option value="Fiction">{lg?.fic}</option>
                <option value="Graphic Novels & Manga">
                  {/* Graphic Novels & Manga */}
                  {lg?.grpnvl}
                </option>
                <option value="Non-Fiction">
                  {/* Non-Fiction */}
                  {lg?.nonfic}
                </option>
                <option value="Others">
                  {lg?.others || "Others"}
                </option>
                <option value="Sci-Fi & Fantasy">
                  {/* Sci-Fi & Fantasy */}
                  {lg?.scifan}
                </option>
                <option value="Young Adults & LGBTQ+">
                  {/* Young Adults & LGBTQ+ */}
                  {lg?.yng}
                </option>

                {/* Add more genres as needed */}
              </Form.Select>
            </div>

            <div className="" style={{ width: "132px", minWidth: "132px" }}>
              <Form.Select
                aria-label="Select Age Group"
                className={`outline11 psx-4 pright pt-0 ftzcopy ${selectedAge ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedAge ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedAge ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedAge} // Bind selected value
                onChange={handleAgeChange} // Handle age selection
              >
                <option value="">{lg?.age}</option>
                {ageRanges.map((ageRange) => (
                  <option
                    key={ageRange._id}
                    value={`${ageRange.minAge}-${ageRange.maxAge}`}
                  >
                    {ageRange.minAge}-{ageRange.maxAge}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="" style={{ width: "200px", minWidth: "200px" }}>
              <Form.Select
                aria-label="Default select example"
                className={`outline11 ${
                  selectedType ? "px-3 " : "pdddx-4 pright"
                } pt-0 ftzcopy large-option ${selectedType ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedType ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedType ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedType} // Bind selected value
                onChange={handleTypeChange}
              >
                <option value="">{lg?.type} </option>
                <option value="Book Club">Book Club (In-person) &nbsp;</option>

                <option value="Book Club online">
                  Book Club (On-line) &nbsp;{" "}
                </option>
                <option value="Book Duo">Book Duo (In-person) &nbsp;</option>

                <option value="Book Duo online">
                  Book Duo (On-line) &nbsp;{" "}
                </option>
                <option value="Silent Reading">Silent reading</option>
              </Form.Select>
            </div>

            <div className="" style={{ width: "150px", minWidth: "150px" }}>
              <Form.Select
                aria-label="Default select example"
                className={`outline11 pl10px pt-0 ftzcopy ${selectedLanguage ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedLanguage ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedLanguage ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedLanguage} // Bind selected value
                onChange={handleLanguageChange}
              >
                <option value="">{lg?.language} </option>
                {languages.map((language) => (
                  <option key={language._id} value={language.code}>
                    {language.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div
              className=""
              style={{
                width: "auto",
                minWidth: "160px",
                maxWidth: "200px",
              }}
            >
              <Form.Select
                aria-label="Default select example"
                className={`outline11 pl10px pt-0 ftzcopy ${selectedSort ? 'selected-filter' : ''}`}
                style={{
                  backgroundColor: selectedSort ? "#70D4D8" : "#ffffff",
                  width: "100%",
                  height: "44px",
                  color: selectedSort ? "#ffffff" : "#3B3B3B",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  lineHeight: "44px",
                  paddingLeft: "14px",
                  paddingRight: "40px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={selectedSort} // Bind selected value
                onChange={handleSortChange}
              >
                <option value="">{lg?.sortby} </option>
                <option value="Descending">
                  {/* Newest First  */}
                  {lg?.morerec}
                </option>
                <option value="Ascending">
                  {/* Oldest First  */}
                  {lg?.lessrec}
                </option>
              </Form.Select>
            </div>

            {/* Reset Filters Button */}
            {isAnyFilterSelected && (
              <div
                className="fw-bold  ftzcopy "
                style={{
                  color: "#34C3C9",
                  lineHeight: "40px",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={handleResetFilters}
              >
                {lg?.resetFilters || "Reset Filters"}
              </div>
            )}
          </div>
          {/* Mobile Filter Button - Removed, now integrated in search row */}

     

          {/* Book list */}

          <div className="mt-4 px-4">
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 sm:gap-4 mb-5">
              {loadings ? (
                // Enhanced Skeleton Loaders
                Array.from({ length: initialLimit }).map((_, index) => (
                  <div
                    key={`skeleton-${index}`}
                    className="border-0 custom-box-card w-full"
                    style={{
                      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
                    }}
                  >
                    {/* Image Skeleton with shimmer effect */}
                    <div
                      className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-lg relative overflow-hidden"
                      style={{
                        width: "100%",
                        maxWidth: "145px",
                        margin: "0 auto",
                        aspectRatio: "147 / 180",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite",
                      }}
                    >
                      <div
                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                        style={{
                          transform: "translateX(-100%)",
                          animation: "shimmer-slide 1.5s infinite",
                        }}
                      ></div>
                    </div>

                    {/* Content Skeleton */}
                    <div className="pt-2 px-2 w-full text-left">
                      {/* Category Badge Skeleton */}
                      <div className="mb-2">
                        <div
                          className="h-5 w-20 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-full"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                          }}
                        ></div>
                      </div>

                      {/* Title Skeleton */}
                      <div className="mb-2">
                        <div
                          className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-3/4 mb-1"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                          }}
                        ></div>
                        <div
                          className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/2"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                            animationDelay: "0.2s",
                          }}
                        ></div>
                      </div>

                      {/* Date Skeleton with icon placeholder */}
                      <div className="mb-2 flex items-center">
                        <div
                          className="h-4 w-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mr-2"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                          }}
                        ></div>
                        <div
                          className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-2/3"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                            animationDelay: "0.1s",
                          }}
                        ></div>
                      </div>

                      {/* Location Skeleton with icon placeholder */}
                      <div className="flex items-center">
                        <div
                          className="h-4 w-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mr-2"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                          }}
                        ></div>
                        <div
                          className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-1/2"
                          style={{
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite",
                            animationDelay: "0.3s",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                filteredBookss.slice(0, visibleCount).map((book, index) => {
                  // Set type dynamically
                  const eventType = book.name; // Default fallback
                  let spotsLeft;
                  if (book?.name === "Book Duo") {
                    if (book?.attendees?.length === 1) {
                      spotsLeft = 0;
                    } else {
                      spotsLeft = 1;
                    }
                  } else {
                    spotsLeft =
                      Number(book?.maxAttendee) -
                      Number(book?.attendees?.length);
                  }

                  console.log("📌 Event Type:", eventType, book); // Debugging ke liye

                  // Set location dynamically
                  let eventLocation = "Default Location"; // Default fallback

                  if (eventType === "Book Club") {
                    eventLocation = "Irish pub";
                  } else if (eventType === "Book Duo") {
                    eventLocation = "TBD";
                  }

                  const eventLink =
                    eventType === "Book Duo"
                      ? `/meetorganizer?bookid=${book._id}&searchbook=true`
                      : eventType === "Book Duo "
                      ? `/meetorganizer?bookid=${book._id}&searchbook=true`
                      : eventType === "Book Club"
                      ? `/groupevent?bookid=${book._id}&searchbook=true`
                      : eventType === "Book Club "
                      ? `/groupevent?bookid=${book._id}&searchbook=true`
                      : eventType === "Silent Reading"
                      ? `/silentreadingabout?bookid=${book._id}&searchbook=true`
                      : "/defaultpage"; // Fallback route agar eventType match na kare
                  return (
                    <Link
                      to={eventLink}
                      rel="noopener noreferrer"
                      key={index}
                      style={{ textDecoration: "none" }}
                      onClick={() => {
                        // Save event data in localStorage
                        const eventData = {
                          type: eventType,
                          location: book.city || eventLocation, // Use dynamic location
                          link: book.link || "",
                          title: book.title,
                          image: book.image,
                          author: book.author,
                          pages: book.pageNumber,
                          genre: book.genre,
                          aboutBook: book.aboutBook,
                          age: book.age,
                          city: book.city,
                          language: book.language,
                          gender: book.gender,
                          detail: book.description,
                          eventType: book.type,
                          createdAt: book?.dateInfo,
                          time: book?.timeTrack,
                          userId: book?.userId,
                          meetingLink: book?.meetingLink,
                          eventId: book._id,
                          attendees: book?.attendees,
                          LangLat: book?.location,
                        };
                        console.log("✅ Event Data:", eventData);

                        localStorage.setItem(
                          "eventDataNew",
                          JSON.stringify(eventData)
                        );
                      }}
                    >
                      <Card
                        key={book._id}
                        className="border-0 custom-box-card w-full"
                      >
                        {book.image ? (
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              maxWidth: "145px",
                              margin: "0 auto",
                              aspectRatio: "147 / 180",
                              flexShrink: 0,
                            }}
                          >
                            <Card.Img
                              className="imgsize157"
                              variant="top"
                              src={resolveBookImageUrl(book?.image)}
                              style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "147px",
                                objectFit: "contain",
                                opacity:
                                  book?.name == "Book Club" ||
                                  book?.name == "Book Duo"
                                    ? spotsLeft === 0
                                      ? 0.3
                                      : 1
                                    : 1,
                              }}
                            />
                            {spotsLeft === 0 &&
                              (book?.name == "Book Club" ||
                                book?.name == "Book Duo") && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform:
                                      "translate(-50%, -50%) rotate(301deg)",
                                    color: "red",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    border: "2px solid red",
                                    padding: "5px 15px",
                                    textTransform: "uppercase",
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  {lg?.full || "FULL"}
                                </div>
                              )}
                          </div>
                        ) : book.name === "Silent Reading" ? (
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              maxWidth: "145px",
                              margin: "0 auto",
                              aspectRatio: "147 / 180",
                            }}
                          >
                            <Card.Img
                              className="imgsize157"
                              variant="top"
                              src={require("./image/book7.jpg")}
                              style={{
                                width: "100%",
                                height: "auto",
                                maxWidth: "147px",
                                objectFit: "contain",
                                opacity:
                                  book?.name == "Silent Reading"
                                    ? spotsLeft === 0
                                      ? 0.3
                                      : 1
                                    : 1,
                              }}
                            />
                            {spotsLeft === 0 &&
                              book?.name == "Silent Reading" && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform:
                                      "translate(-50%, -50%) rotate(301deg)",
                                    color: "red",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    border: "2px solid red",
                                    padding: "5px 15px",
                                    textTransform: "uppercase",
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    pointerEvents: "none",
                                  }}
                                >
                                  {lg?.full || "FULL"}
                                </div>
                              )}
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "147px",
                              margin: "0 auto",
                              aspectRatio: "147 / 180",
                              backgroundColor: "#e0e0e0",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#777",
                            }}
                          >
                            No Image
                          </div>
                        )}

                        <Card.Body className="text-left ftzgern mt-3 m-0 card-title pb-0 h5" style={{ minWidth: 0 }}>
                          <div className="mb-2">
                            <Card.Title
                              className="text-left ftzgern inline-block"
                              style={{
                                backgroundColor:
                                  book.name === "Book Club"
                                    ? "#D9EAD3"
                                    : book.name === "Silent Reading"
                                    ? "#DBEAFE"
                                    : book.name === "Book Duo"
                                    ? "#FFE4E6"
                                    : "transparent", // default bg
                                color:
                                  book.name === "Book Club"
                                    ? "#1F5130"
                                    : book.name === "Silent Reading"
                                    ? "#1E3A8A"
                                    : book.name === "Book Duo"
                                    ? "#BE123C"
                                    : "#000000", // default text color
                                fontFamily: "Inter",
                                fontWeight: "600",
                                cursor: "pointer",
                                borderRadius: "50px", // optional: make label pill-like
                                padding: "3px 8px", // reduced padding
                                display: "inline-block", // keeps label compact
                                fontSize: "13px",
                                margin: 0,
                              }}
                              // onClick={() => handleEventTypeClick(book)}
                            >
                              {book?.name}
                            </Card.Title>
                          </div>

                          <Card.Title
                            className="w-full text-[17px] sm:text-[19px] font-[600] sm:font-[700] mb-2"
                            style={{
                              color: "#000000",
                              fontFamily: "Inter",
                              marginTop: "0px",
                              marginBottom: "0px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              width: "100%",
                            }}
                          >
                            {book?.name === "Silent Reading"
                              ? lg?.yownbook || "Your Own Book"
                              : book.title}
                          </Card.Title>

                          <Card.Text
                            className="w-full mt-1 ftzgern"
                            style={{
                              color: "#4B5563", // Tailwind gray-600
                              fontSize: "14px",
                              fontFamily: "Open Sans",
                              fontWeight: "500",
                              lineHeight: "20px",
                            }}
                          >
                            {/* Date */}
                            <div className="d-flex align-items-center mb-1">
                              <CalendarDays
                                size={16}
                                style={{
                                  marginRight: "6px",
                                  color: "#6B7280",
                                }}
                              />
                              {book?.name === "Book Duo"
                                ? "TBD"
                                : (() => {
                                    // Translate day abbreviation
                                    const dayMap = {
                                      "Mon": lg?.dayMon || "Mon",
                                      "Tue": lg?.dayTue || "Tue",
                                      "Wed": lg?.dayWed || "Wed",
                                      "Thu": lg?.dayThu || "Thu",
                                      "Fri": lg?.dayFri || "Fri",
                                      "Sat": lg?.daySat || "Sat",
                                      "Sun": lg?.daySun || "Sun",
                                    };
                                    // Translate month abbreviation
                                    const monthMap = {
                                      "Jan": lg?.monthAbbrJan || "Jan",
                                      "Feb": lg?.monthAbbrFeb || "Feb",
                                      "Mar": lg?.monthAbbrMar || "Mar",
                                      "Apr": lg?.monthAbbrApr || "Apr",
                                      "May": lg?.monthAbbrMay || "May",
                                      "Jun": lg?.monthAbbrJun || "Jun",
                                      "Jul": lg?.monthAbbrJul || "Jul",
                                      "Aug": lg?.monthAbbrAug || "Aug",
                                      "Sep": lg?.monthAbbrSep || "Sep",
                                      "Oct": lg?.monthAbbrOct || "Oct",
                                      "Nov": lg?.monthAbbrNov || "Nov",
                                      "Dec": lg?.monthAbbrDec || "Dec",
                                    };
                                    const translatedDay = dayMap[book?.dateInfo?.dayName] || book?.dateInfo?.dayName;
                                    const translatedMonth = monthMap[book?.dateInfo?.month] || book?.dateInfo?.month;
                                    return `${translatedDay}, ${book?.dateInfo?.day} ${translatedMonth} ${book?.dateInfo?.year}`;
                                  })()}
                            </div>

                            <div className="d-flex align-items-center">
                              {book?.type === "On-line" ? (
                                <>
                                  <Video
                                    size={16}
                                    style={{
                                      marginRight: "6px",
                                      color: "#6B7280",
                                    }}
                                  />
                                  <span>{lg?.online || "Online"}</span>
                                </>
                              ) : (
                                <>
                                  <MapPin
                                    size={16}
                                    style={{
                                      marginRight: "6px",
                                      color: "#6B7280",
                                    }}
                                  />
                                  <span>
                                    {book?.city?.length > 12
                                      ? book.city.substring(0, 12) + "..."
                                      : book?.city}
                                  </span>
                                </>
                              )}
                            </div>
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </Link>
                  );
                })
              )}
            </div>
          </div>

          {!loadings && !showAll && (
            <div
              className="font-bold text-lg underline mt-4 ftzevtt text-center px-4"
              style={{ color: "#34C3C9", cursor: "pointer" }}
              onClick={handleSeeMoreClick}
            >
              {/* See more events */}
              {lg?.smoreevent}
            </div>
          )}
        </div>

       
      </div>
      <div
          id="booksandreviewsboxws"
          className="w-100 evebtbg mt-5 border-0 "
          style={{
            // height: "550px",
            border: "1px solid #34C3C9",
            backgroundColor: "#f2f2f2",
          }}
        >
          <div className="sclnone !px-4 !py-20">
            <div
              className="text-center fw-bold pb-12 wolcom"
              style={{ fontSize: "27px", color: "#34C3C9" }}
            >
              {/* Do you want to create your own event? */}
              {lg?.dowant}
            </div>

            <div className="d-flex flex-wrap gap-lg-4 gap-3 justify-content-center align-items-stretch">
              <div className="w-100 bg-white evbtwidhei px-4 py-3 fw-normal card-boxh d-flex flex-column">
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <Users size={48} color="#34c3c9" />
                </div>

                <div className="d-flex align-items-center justify-content-center">
                  <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                    {lg?.bookDuoTitle || "Book Duo"}
                  </div>
                </div>
                <div className="card-texth flex-grow-1">
                  <div className="w-100 bookduoftz pt-2 mx-2">
                    {lg?.BookDuoSecondText ||
                      lg?.BookDuoFirstText ||
                      "Looking for a personal connection? Choose a book, select a partner's age and gender preference, and start a one-to-one literary journey."}
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <button
                    className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-fit px-3 py-2 !h-auto  card-btnh"
                    onClick={() => navigate("/createmeetup")}
                  >
                    {/* Create Book Duo */}
                    {lg?.cbduo}
                  </button>
                </div>
              </div>

              <div className="w-100 bg-white evbtwidhei px-4 py-3 fw-normal card-boxh d-flex flex-column">
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <Coffee size={48} color="#34c3c9" />
                </div>

                <div className="d-flex align-items-center justify-content-center">
                  <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                    {lg?.bookClubTitle || "Book Club"}
                  </div>
                </div>
                <div className="card-texth flex-grow-1">
                  <div
                    className="w-100 bookduoftz pt-2"
                    style={{ wordSpacing: "5px" }}
                  >
                    {lg?.BookClubSecondText ||
                      lg?.BookClubFirstText ||
                      "Join welcoming in-person or online book clubs hosted in cozy settings. Each group is facilitated by an Ambassador to ensure a lively and inclusive experience."}
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <button
                    className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-fit px-3 py-2 !h-auto  card-btnh"
                    onClick={handleAmbasButtonClick}
                  >
                    {/* Create Book Club */}
                    {lg?.ClubBtnText}
                  </button>
                </div>
              </div>

              <div className="w-100 bg-white evbtwidhei px-4 py-3 fw-normal card-boxh d-flex flex-column">
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <BookOpen size={48} color="#34c3c9" />
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <div className="mb-md-2 mb-sm-2 fw-bold bookduo card-titleh">
                    {lg?.bookSilentTitle || "Silent reading"}
                  </div>
                </div>
                <div className="card-texth flex-grow-1">
                  <div
                    className="w-100 bookduoftz pt-2 mx-2"
                    style={{ wordSpacing: "5px" }}
                  >
                    {lg?.BookSilentSecondText ||
                      lg?.BookSilentFirstText ||
                      "Enjoy peaceful silent reading sessions. Bring your own book, relax, and share the quiet joy of reading together."}
                  </div>
                </div>
                <div className="text-center mt-auto">
                  <button
                    className="fs-18 btngropwid fw600 border-0 mt-2 rounded-1 !text-white text-center w-fit px-3 py-2 !h-auto card-btnh"
                    onClick={handleReadingButtonClick}
                  >
                    {/* Create Silent Reading */}
                    {lg?.SilentBtnText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer2 />

      {/* OLD CODE - Future use: Ambassador restriction modal */}
      {/* <Modal
        show={wShow}
        onHide={handleCloseW}
        centered
        className="custom-gropmodelwel roundedambdmodl"
        backdrop={true}
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnevtn2 top-0 mt-4 mx-4 "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleCloseW}
          />
        </Modal.Header>
        <Modal.Title className="mx-5 "></Modal.Title>
        <Modal.Body className="mx-4 mt-sm-2">
          <div
            className="fw-bold text-center mt-lg-2 w-100 ftzinput "
            style={{ fontSize: "24px" }}
          >
            {lg?.ledAmbsdr}
          </div>
          <div
            className="fw-bold text-center w-100 mt-lg-4 mt-2 ftzinput "
            style={{ fontSize: "24px" }}
          >
            <span
              className="text-decoration-underline"
              style={{ color: "#34c3c9", cursor: "pointer" }}
              onClick={handleAmbasButtonClickModel}
            >
              {lg?.bAnAmbsdor}
            </span>
            {lg?.leadText}
            <span
              className="text-decoration-underline"
              style={{ color: "#34c3c9", cursor: "pointer" }}
              onClick={handleLocationClick}
            >
              {lg?.evtnear}
            </span>
          </div>
        </Modal.Body>
      </Modal> */}
      <CustomModal show={showPopup} onHide={handleCloseModal}>
        {/* Modal Header */}
        <div
          className="d-flex align-items-center justify-content-between p-4 border-bottom"
          style={{ borderColor: "#E5E7EB" }}
        >
          <h3
            className="m-0 fw-bold"
            style={{
              fontSize: "24px",
              fontFamily: "Open Sans",
              color: "#1F2937",
            }}
          >
            {lg?.filters || "Filters"}
          </h3>
          <button
            onClick={handleCloseModal}
            className="border-0 bg-transparent p-2"
            style={{
              cursor: "pointer",
              borderRadius: "8px",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#F3F4F6";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#6B7280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body */}
        <div
          className="p-4"
          style={{
            maxHeight: "60vh",
            overflowY: "auto",
            backgroundColor: "#F9FAFB",
          }}
        >
          <FilterSection
            title={lg?.month || "Month"}
            options={[lg?.month || "Any month", ...months]}
            selectedValue={selectedMonth}
            onSelect={setSelectedMonth}
          />

          <FilterSection
            title={lg?.genre || "Genre"}
            options={[
              lg?.genre || "Genre",
              { value: "Crime", label: lg?.cri || "Crime" },
              { value: "Fiction", label: lg?.fic || "Fiction" },
              {
                value: "Graphic Novels & Manga",
                label: lg?.grpnvl || "Graphic Novels & Manga",
              },
              { value: "Non-Fiction", label: lg?.nonfic || "Non-Fiction" },
              { value: "Others", label: lg?.others || "Others" },
              {
                value: "Sci-Fi & Fantasy",
                label: lg?.scifan || "Sci-Fi & Fantasy",
              },
              {
                value: "Young Adults & LGBTQ+",
                label: lg?.yng || "Young Adults & LGBTQ+",
              },
            ]}
            selectedValue={selectedGenre}
            onSelect={setSelectedGenre}
            renderLabel={(option) => option.label || option}
          />

          <FilterSection
            title={lg?.age || "Age"}
            options={ageRanges.map((ageRange) => ({
              value: `${ageRange.minAge}-${ageRange.maxAge}`,
              label: `${ageRange.minAge}-${ageRange.maxAge}`,
            }))}
            selectedValue={selectedAge}
            onSelect={setSelectedAge}
            renderLabel={(option) =>
              option.label || `${option.minAge}-${option.maxAge}`
            }
          />

          <FilterSection
            title={lg?.type || "Type"}
            options={[
              lg?.type || "Type",
              "Book Club",
              "Book Club online",
              "Book Duo",
              "Book Duo online",
              "Silent Reading",
            ]}
            selectedValue={selectedType}
            onSelect={setSelectedType}
          />

          <FilterSection
            title={lg?.language || "Language"}
            options={[
              { value: "", label: lg?.language || "Language" }, // placeholder
              ...languages.map((language) => ({
                value: language.code,
                label: language.name,
              })),
            ]}
            selectedValue={selectedLanguage}
            onSelect={setSelectedLanguage}
          />

          <FilterSection
            title={lg?.sortby || "Sort by"}
            options={[
              { value: "", label: lg?.sortby || "Sort by" },
              { value: "Descending", label: lg?.morerec || "Newest First" },
              { value: "Ascending", label: lg?.lessrec || "Oldest First" },
            ]}
            selectedValue={selectedSort}
            onSelect={setSelectedSort}
            renderLabel={(option) => option.label}
          />
        </div>

        {/* Modal Footer */}
        <div
          className="p-4 border-top bg-white"
          style={{ borderColor: "#E5E7EB" }}
        >
          <div className="d-flex gap-3">
            {isAnyFilterSelected && (
              <button
                onClick={handleResetFilters}
                className="flex-fill py-3 border bg-white"
                style={{
                  borderColor: "#D1D5DB",
                  color: "#374151",
                  fontSize: "16px",
                  fontFamily: "Open Sans",
                  fontWeight: "600",
                  borderRadius: "12px",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#F3F4F6";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "white";
                }}
              >
                {lg?.resetAll || "Reset All"}
              </button>
            )}
            <button
              onClick={handleCloseModal}
              className="flex-fill py-3 text-white border-0"
              style={{
                backgroundColor: "#34C3C9",
                fontSize: "16px",
                fontFamily: "Open Sans",
                fontWeight: "600",
                borderRadius: "12px",
                transition: "all 0.2s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#2BB3BA";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#34C3C9";
              }}
            >
              {lg?.applyFilters || "Apply Filters"}
            </button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default BooksAndReview;
